import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { ButtonType, ButtonWidget, HorizontalOriginOption, TabStyles, VerticalOriginOption } from '@tableau/widgets';
import React, { useRef } from 'react';

import { usePrevious } from '~src/bootstrap/hooks';
import { CatalogProviders } from '~src/catalog/CatalogProviders';
import { Messages } from '~src/codegen/Localize';
import { ButtonWithUberDialog } from '~src/commonInfra/components/ButtonWithUberDialog';

import { DataQualityTriggerConfigurationUI, DataQualityTriggerConfigurationUIAction } from './DataQualityTriggerDialog';

export type DataQualityTriggerUberDialogProps = {
  readonly dispatch: React.Dispatch<DataQualityTriggerConfigurationUIAction>;
  readonly isActive: boolean;
  readonly isSevere: boolean;
  readonly message: string;
}

export function DataQualityTriggerUberDialog(props: DataQualityTriggerUberDialogProps): JSX.Element {
  const buttonRef = useRef<HTMLButtonElement>();
  const previousEnableTrigger: boolean = usePrevious(props.isActive);
  React.useLayoutEffect(
    // when the dqw checkbox is checked, open the dialog
    () => {
      // the previous value in the initial render will always be undefined so need to explicitly check if it's false
      if (previousEnableTrigger === false && props.isActive) {
        buttonRef.current?.click();
       }
    },[previousEnableTrigger, props.isActive]
  );
  const buttonProps = {
    testId: 'LinkedTaskUberDQW',
    buttonType: ButtonType.Icon,
    title: Messages.dataQualityTriggerDialog_Title_Flow(),
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
      marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
    }
  };

    return(
      <ButtonWithUberDialog
        dialogWidth={500}
        renderButton={showDialog => (
            <ButtonWidget {...buttonProps} onClick={showDialog} buttonRef={buttonRef}>
              <PencilBaseIcon
                alt={''}
                size={14}
              />
            </ButtonWidget>
        )}
        uberDialogContent={
        <CatalogProviders>
          <DataQualityTriggerConfigurationUI
            contentType={'flow'}
            isActive={props.isActive}
            isSevere={props.isSevere}
            message={props.message}
            dispatch={props.dispatch}
            dialogType={'FLOW_RUN_FAILURE'}
          />
        </CatalogProviders>
        }
        // the defaults caused the dialog to jump
        anchorOrigin={{ horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.top }}
        stackedOrigin={{ horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.top }}
      />
    );
  }




